import { motion } from 'framer-motion';
import { EDITORIAL } from './data';

// EDITORIAL — gallery essay layout. NO image hero, just type.
export default function Editorial() {
  const [hero, ...rest] = EDITORIAL;
  return (
    <div className="bg-[#F4F1EA] text-[#0A0A0A]">
      <section className="pt-12 pb-10 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#0A0A0A]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B53024] mb-4">— Editorial · From the gallery</p>
        <h1 className="font-serif text-[44px] sm:text-[64px] lg:text-[88px] leading-[1.02] tracking-tight">Looking, <span className="italic text-[#B53024]">slowly</span>.</h1>
      </section>

      {/* Hero essay — two columns of text only */}
      <article className="max-w-[1100px] mx-auto px-8 lg:px-14 py-20">
        <div className="grid md:grid-cols-[1fr_2fr] gap-10">
          <div className="md:sticky md:top-32 self-start">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B53024]">Featured · {hero.date}</p>
            <h2 className="font-serif text-3xl lg:text-5xl mt-4 leading-tight">{hero.title}</h2>
            <p className="font-serif italic text-lg text-[#0A0A0A]/65 mt-3">{hero.sub}</p>
            <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#0A0A0A]/45 mt-6">By Margaret Vale &middot; {hero.read} read</p>
          </div>
          <div className="font-serif text-lg lg:text-xl text-[#0A0A0A]/85 leading-[1.7] columns-1 md:columns-1 gap-10">
            <p className="first-letter:font-serif first-letter:text-7xl first-letter:float-left first-letter:mr-3 first-letter:mt-1 first-letter:leading-[0.85] first-letter:text-[#B53024]">When we hung the Hammershøi for the first time, on a snowy morning in February, the room held its breath for nearly thirty minutes before any of us spoke. It is, I believe, the most important painting we have ever shown.</p>
            <br />
            <p>Slow paintings ask for slow rooms. We have written, often, about how a single excellent painting in a quiet wall is worth twenty fine ones crowded together. The exhibition you are about to see is built on this conviction.</p>
            <br />
            <p>Each painting is given a wall to itself. Most rooms hold a single work. The catalogue we have printed contains eight times as much white space as it does ink. A small protest, perhaps, against the noise of our trade.</p>
          </div>
        </div>
      </article>

      {/* Pull quote */}
      <section className="bg-[#0A0A0A] text-[#F4F1EA] py-20">
        <div className="max-w-[900px] mx-auto px-8 lg:px-14">
          <p className="font-serif text-3xl lg:text-5xl leading-[1.2] italic">&ldquo;A painting that has waited a hundred years for the right room can wait a few more weeks for the right collector.&rdquo;</p>
          <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#B53024] mt-8">— Anders Lindholm, founder, in conversation with the FT, 2019</p>
        </div>
      </section>

      {/* Other essays — index style */}
      <section className="max-w-[1100px] mx-auto px-8 lg:px-14 py-20">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#B53024] mb-10">— Other essays</p>
        <div className="border-t border-[#0A0A0A]/15">
          {rest.map(e => (
            <a key={e.title} href="#" className="grid grid-cols-[100px_1fr_auto] gap-6 py-7 border-b border-[#0A0A0A]/15 hover:text-[#B53024] group items-baseline">
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#0A0A0A]/45">{e.date}</span>
              <div>
                <p className="font-serif text-2xl lg:text-3xl group-hover:italic" dangerouslySetInnerHTML={{ __html: e.title }} />
                <p className="font-serif italic text-base text-[#0A0A0A]/55 mt-1">{e.sub}</p>
              </div>
              <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#0A0A0A]/40 group-hover:text-[#B53024]">{e.read} →</span>
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}
